export const environment = {
  production: false,
  datadogEnv: 'staging',
  domain: 'staging.geloc.latouretpetit.app',
  appVersion: require('../../package.json').version + "-staging",
  posthogKey: 'phc_V5HQIYrlpZgzoSVyra7ozEuwWohyVR76YxsAlaZ0RJz',
  posthogHost: 'https://eu.i.posthog.com',
  posthogProxy: 'https://glo.latouretpetit.link'
};

